<template>
    <client-page>

        <sub-visual
        sh="About IST"
        tabActive="Certification Status"
        bg="/images/sub/visual/sv1.png">
        </sub-visual>

        <section class="sub-section sub-section--first">
            <v-container>
                <h2 class="page-tit">
                    Certification Status
                </h2>
            </v-container>
            <top-image
            src="/images/sub/about/status/status-img.png">
            </top-image>
        </section>
        
        <section class="sub-section">
            <v-container>
                <h4 class="tit--md font-weight-bold line-height-1 mb-28 mb-lg-40">
                    인증 취득 현황
                </h4>

                <v-row class="my-n10 my-lg-n40">

                    <certification
                    num="품질경영 시스템"
                    src="/images/sub/about/status/cert2-1.png">
                        ISO 9001:2015
                    </certification>

                    <certification
                    num="환경경영 시스템"
                    src="/images/sub/about/status/cert2-2.png">
                        ISO 14001:2015
                    </certification>

                    <certification
                    num="정보보안경영 시스템"
                    src="/images/sub/about/status/cert2-3.png">
                        ISO 27001 : 2013
                    </certification>

                    <certification
                    num="안전보건경영 시스템"
                    src="/images/sub/about/status/cert2-4.png">
                        ISO 45001:2018
                    </certification>

                </v-row>
            </v-container>
        </section>
        
        <section class="sub-section sub-section--last">
            <v-container>
                <h4 class="tit--md font-weight-bold line-height-1 mb-28 mb-lg-40">
                    특허 취득 현황
                </h4>

                <v-row class="my-n10 my-lg-n40">

                    <certification
                    num="특허 제 10-0879086 호"
                    src="/images/sub/about/status/cert1-1.png">
                        웨이퍼 연마용 <br class="d-none d-lg-block">
                        리테이너 링
                    </certification>

                    <certification
                    num="특허 제 10-1123870 호"
                    src="/images/sub/about/status/cert1-2.png">
                        웨이퍼 연마용 리테이너 링 <br class="d-none d-lg-block">
                        제조방법
                    </certification>

                    <certification
                    num="특허 제 10-1364089 호"
                    src="/images/sub/about/status/cert1-3.png">
                        웨이퍼 연마용 리테이너 링 <br class="d-none d-lg-block">
                        및 그 제조방법
                    </certification>

                    <certification
                    num="특허 제 10-2246289 호"
                    src="/images/sub/about/status/cert1-4.png">
                        재사용이 가능한 웨이퍼 연마용 <br class="d-none d-lg-block">
                        리테이너 링 및 그 제조방법
                    </certification>

                    <certification
                    num="특허 제 10-0879085 호"
                    src="/images/sub/about/status/cert1-5.png">
                        웨이퍼 연마용 <br class="d-none d-lg-block">
                        리테이너 링
                    </certification>

                    <certification
                    num="특허 제 10-0884236 호"
                    src="/images/sub/about/status/cert1-6.png">
                        웨이퍼 연마용 <br class="d-none d-lg-block">
                        리테이너 링
                    </certification>

                    <certification
                    num="특허 제 10-2247867 호"
                    src="/images/sub/about/status/cert1-7.png">
                        마찰 용접을 이용한 리테이너 링, <br class="d-none d-lg-block">
                        그 제조 장치 및 방법
                    </certification>

                </v-row>
            </v-container>
        </section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import TopImage from "@/components/client/ko/sub/sub-top-image.vue";
import Certification from "@/components/client/ko/sub/sub-certification.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        TopImage,
        Certification,
    },
};
</script>

<style lang="scss" scoped>
</style>